// Generated by BUCKLESCRIPT VERSION 2.1.0, PLEASE EDIT WITH CARE
'use strict';

var Cell        = require("./cell");
var List        = require("bs-platform/lib/js/list.js");
var $$Array     = require("bs-platform/lib/js/array.js");
var Block       = require("bs-platform/lib/js/block.js");
var Board       = require("./board");
var Curry       = require("bs-platform/lib/js/curry.js");
var React       = require("react");
var ReasonReact = require("reason-react/lib/js/src/ReasonReact.js");

var life = ReasonReact.reducerComponent("Life");

function make() {
  return /* record */[
          /* debugName */life[/* debugName */0],
          /* reactClassInternal */life[/* reactClassInternal */1],
          /* handedOffState */life[/* handedOffState */2],
          /* willReceiveProps */life[/* willReceiveProps */3],
          /* didMount */(function (self) {
              self[/* state */2][/* timerId */1][0] = /* Some */[setInterval((function () {
                        return Curry._1(self[/* send */4], /* Tick */2);
                      }), 1000)];
              return /* NoUpdate */0;
            }),
          /* didUpdate */life[/* didUpdate */5],
          /* willUnmount */(function (self) {
              if (self[/* state */2][/* running */0]) {
                var match = self[/* state */2][/* timerId */1][0];
                if (match) {
                  clearInterval(match[0]);
                  return /* () */0;
                } else {
                  return /* () */0;
                }
              } else {
                return 0;
              }
            }),
          /* willUpdate */(function (param) {
              var newSelf = param[/* newSelf */1];
              var oldSelf = param[/* oldSelf */0];
              if (oldSelf[/* state */2][/* running */0] && !newSelf[/* state */2][/* running */0]) {
                var match = newSelf[/* state */2][/* timerId */1][0];
                if (match) {
                  clearInterval(match[0]);
                }
                
              }
              if (!oldSelf[/* state */2][/* running */0] && newSelf[/* state */2][/* running */0]) {
                newSelf[/* state */2][/* timerId */1][0] = /* Some */[setInterval((function () {
                          return Curry._1(newSelf[/* send */4], /* Tick */2);
                        }), 1000)];
                return /* () */0;
              } else {
                return 0;
              }
            }),
          /* shouldUpdate */life[/* shouldUpdate */8],
          /* render */(function (param) {
              var send = param[/* send */4];
              return React.createElement("div", undefined, React.createElement("div", {
                              className: "board"
                            }, $$Array.of_list(List.mapi((function (x, row) {
                                        return React.createElement("span", {
                                                    className: "row"
                                                  }, $$Array.of_list(List.mapi((function (y, cellData) {
                                                              return ReasonReact.element(/* None */0, /* None */0, Cell.make(cellData, (function () {
                                                                                return Curry._1(send, /* ToggleCell */[
                                                                                            x,
                                                                                            y
                                                                                          ]);
                                                                              }), /* array */[]));
                                                            }), row)));
                                      }), param[/* state */2][/* board */2]))), React.createElement("button", {
                              onClick: (function () {
                                  return Curry._1(send, /* StartTimer */0);
                                })
                            }, "Start"), React.createElement("button", {
                              onClick: (function () {
                                  return Curry._1(send, /* StopTimer */1);
                                })
                            }, "Stop"), React.createElement("button", {
                              onClick: (function () {
                                  return Curry._1(send, /* ResetBoard */3);
                                })
                            }, "Reset"));
            }),
          /* initialState */(function () {
              return /* record */[
                      /* running : true */1,
                      /* timerId */[/* None */0],
                      /* board */Board.generate(30, /* Random */1),
                      /* size */30
                    ];
            }),
          /* retainedProps */life[/* retainedProps */11],
          /* reducer */(function (action, state) {
              if (typeof action === "number") {
                switch (action) {
                  case 0 : 
                      return /* Update */Block.__(0, [/* record */[
                                  /* running : true */1,
                                  /* timerId */state[/* timerId */1],
                                  /* board */state[/* board */2],
                                  /* size */state[/* size */3]
                                ]]);
                  case 1 : 
                      return /* Update */Block.__(0, [/* record */[
                                  /* running : false */0,
                                  /* timerId */state[/* timerId */1],
                                  /* board */state[/* board */2],
                                  /* size */state[/* size */3]
                                ]]);
                  case 2 : 
                      var newBoard = Board.tick(state[/* board */2]);
                      return /* Update */Block.__(0, [/* record */[
                                  /* running */state[/* running */0],
                                  /* timerId */state[/* timerId */1],
                                  /* board */newBoard,
                                  /* size */state[/* size */3]
                                ]]);
                  case 3 : 
                      var newBoard$1 = Board.generate(state[/* size */3], /* Random */1);
                      return /* Update */Block.__(0, [/* record */[
                                  /* running */state[/* running */0],
                                  /* timerId */state[/* timerId */1],
                                  /* board */newBoard$1,
                                  /* size */state[/* size */3]
                                ]]);
                  
                }
              } else {
                var newBoard$2 = Board.toggleCell(state[/* board */2], action[0], action[1]);
                return /* Update */Block.__(0, [/* record */[
                            /* running */state[/* running */0],
                            /* timerId */state[/* timerId */1],
                            /* board */newBoard$2,
                            /* size */state[/* size */3]
                          ]]);
              }
            }),
          /* subscriptions */life[/* subscriptions */13],
          /* jsElementWrapped */life[/* jsElementWrapped */14]
        ];
}

exports.life = life;
exports.make = make;
/* life Not a pure module */



//////////////////
// WEBPACK FOOTER
// ./src/life.re
// module id = 39
// module chunks = 0